import React from "react";
import { Helmet } from "react-helmet-async";
import "./BlogTemplate.css"; // Make sure this matches your CSS file name

const BlogTemplate = ({ 
  seoTitle, 
  seoDescription, 
  seoKeywords, 
  ogImage, 
  pageUrl, 
  bannerTitle, 
  children 
}) => {
  return (
    <>
      <Helmet>
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:site_name" content="NexTech PLM Solutions" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:image:secure_url" content={ogImage} />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />
      </Helmet>

      {/* Standardized Top Banner */}
      <section className="blog-banner">
        <h1 className="banner-title">{bannerTitle}</h1>
      </section>

      {/* The unique content of each blog post is injected here */}
      <main className="blog-content-wrapper">
        {children}
      </main>
    </>
  );
};

export default BlogTemplate;